import React, { InputHTMLAttributes } from "react";

export type TextAreaProps = InputHTMLAttributes<HTMLTextAreaElement> & {
    textAreaRef?: React.Ref<HTMLTextAreaElement>
};

const TextArea = ({
  name,
  className = "",
  children,
  onChange,
  value,
  textAreaRef,
  ...rest
}: TextAreaProps) => {
  return (
    <>
        <textarea
          className={`rounded-8 form-control  ${className}`}
          type="text"
          name={name || undefined}
          value={value }
          onChange={(event) => {
            if (!onChange) return;
            onChange(event);
          }}
          {...rest}
          rows={1}
          ref={textAreaRef}
        />
        {children}
    </>
  );
};

export default TextArea;
